export default __webpack_public_path__ + "static/pathways-background-2-8238ddfe9f2bb78aa6702c5b07e438d5.png";